import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from '@common/seo/helmet';
import { DefaultMetaTags } from '@common/seo/default-meta-tags';
export function PageMetaTags({ query }) {
    if (query.data?.set_seo) {
        return null;
    }
    return query.data?.seo ? (_jsx(Helmet, { tags: query.data.seo })) : (_jsx(DefaultMetaTags, {}));
}
